import React from "react";
import CancelApplication from "../CancelApplication/CancelApplication";
import CallApplication from "../CallApplication/CallApplication";
// import { useParams } from "react-router-dom";
import WebDirectReservation from "../WebDirectReservation/WebDirectReservation";

const ApplicationRouter = ({ kind, customerNo, code, customerInfo }) => {
  //   const { kind, customerNo } = useParams();

  //console.log ( kind, customerNo, code, customerInfo)

  return (
    <div>
      {/* <div>Kind: {kind}</div>
      <div>Customer ID: {customerNo}</div> */}
      {kind === "1" && <CancelApplication customerInfo={customerInfo} kind={kind} customerNo={customerNo} code={code} />}
      {kind === "2" && <CallApplication customerInfo={customerInfo} kind={kind} customerNo={customerNo} code={code} />}
      {kind === "3" && <WebDirectReservation customerInfo={customerInfo} kind={kind} customerNo={customerNo} code={code} />}
    </div>
  );
};

export default ApplicationRouter;
